export function arc(ctx) {
    return {
        styles: {
            main:      { ...ctx.pretty, radius: 5, line_color: '#ffffff', line_width: 15 },
            indicator: { line_color: '#ffffff', line_width: 15, line_rounded: true },
            knob:      { bg_color: '#ffffff', padding: 0, border_width: 0, border_color: '#ffffff' },
        },
    };
}
